import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { isLoading, isNormal, useStatus, useData } from 'resift';
import makeStyles from '@material-ui/core/styles/makeStyles';
import getRoles from 'fetches/rolesAndPermissions/getRoles';

import CircularProgress from '@material-ui/core/CircularProgress';
import RolesTab from './RolesTab';

function Container() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const status = useStatus(getRoles);
  const data = useData(getRoles);

  useEffect(() => {
    dispatch(getRoles({ expandMemberCount: true }));
  }, []);

  if (isLoading(status)) {
    return <CircularProgress color="secondary" className={classes.loading} />;
  }

  if (!isNormal(status)) {
    return <div>Something went wrong.</div>;
  }

  return <RolesTab roles={data.results} />;
}

const useStyles = makeStyles(theme => ({
  root: {},
  loading: {
    display: 'flex',
    margin: 'auto',
  },
}));

export default Container;
